export default () => {
    return [
        {
            path: '/richiestePagamento',
            name: 'richiestePagamento',
            component: () => import('./views/richiestePagamento.vue'),
        },
    ];
};
